import { RouteConfig } from 'vue-router';
import MswDashboard from './components/msw-dashboard.vue';

const route:RouteConfig = {
  path: 'dashboard',
  component: MswDashboard,
};

export function getDefaultParams() {
  return {};
}

export default route;
